import React, { FC } from 'react';
import { Route } from 'react-router';

import AgreementsTable from '../components/agreements/table';
import AgreementCreate from '../components/agreements/create';
import AgreementEdit from '../components/agreements/edit';
const AgreemensPage: FC = () => {
  return (
    <>
      <Route exact path="/agreements/edit/:id" component={AgreementEdit} />
      <Route exact path="/agreements/create" component={AgreementCreate} />
      <Route exact path="/agreements/" component={AgreementsTable} />
    </>
  );
};

export default AgreemensPage;
